import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import ApplyDialog from "./ApplyDialog";

export default function JoinTeam() {
  return (
    <section className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="bg-[#d6e4be] rounded-[2.5rem] p-10 lg:p-16 grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#143527] mb-4">
              Join Our Crew
            </p>
            <h2 className="font-serif text-4xl lg:text-5xl leading-[1.1] text-[#143527] mb-5">
              Hire fast. Grow with us.
            </h2>
            <p className="text-[16px] text-[#143527]/80 leading-relaxed">
              Experienced cleaners, aviation detailers and event crews &mdash; we&rsquo;re always hiring trained
              professionals with flexible schedules and steady pay.
            </p>
          </div>
          <div className="flex flex-col items-start lg:items-end gap-4">
            <ApplyDialog
              trigger={
                <Button className="rounded-full px-8 py-6 btn-primary text-[15px] group">
                  Apply to join Tidy
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
              }
            />
            <p className="text-sm text-[#143527]/65">No experience? Paid training available.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
